var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandSwipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.982053,9.03694444 L17.9869975,9.25 L17.9869395,14.166 L18.0989975,14.13 C19.5389975,13.6966667 21.2789975,14.3466667 21.8189975,16.08 L21.8569395,16.215 L21.956053,16.1769444 C23.4216641,15.654537 25.2609975,16.2888889 25.8189975,18.08 L25.8569395,18.215 L25.956053,18.1769444 C27.658053,17.5702778 29.864053,18.5236111 29.982053,21.0369444 L29.9869975,21.25 L29.9869975,33.24 C29.9869975,34.8408198 28.7899365,36.1531836 27.2208316,36.244882 L27.0449975,36.25 L15.0439975,36.25 C14.3257515,36.25 13.6062184,35.9774136 13.0604341,35.5011326 L12.9160232,35.3662393 L4.90870179,27.3619178 C3.64096388,26.0935024 3.74854315,24.2998594 4.91082591,23.1315877 C6.03131857,22.0053213 7.73560303,21.8591486 8.99594773,22.9855107 L9.1393435,23.1211396 L11.9869395,25.987 L11.9869975,9.25 C11.9869975,4.98888889 17.7886641,4.91787037 17.982053,9.03694444 Z M13.9927348,9.09863281 L13.9869975,9.25 L13.9869975,30.8370844 L7.72289068,24.5331068 C7.27730696,24.0875231 6.74788916,24.120782 6.32866901,24.5421623 C5.93811537,24.9347284 5.88252104,25.424565 6.23448218,25.8506407 L6.32297174,25.9477607 L14.3301042,33.9518932 C14.4834239,34.1052128 14.7007735,34.2100184 14.9157949,34.2406947 L15.0439975,34.25 L27.0449975,34.25 C27.5355494,34.25 27.927311,33.875955 27.9807741,33.361185 L27.9869975,33.24 L27.9869975,21.25 C27.9869975,19.6354167 26.1100443,19.5849609 25.9927348,21.0986328 L25.9869975,21.25 L23.9869975,21.25 L23.9869975,19.25 C23.9869975,17.6354167 22.1100443,17.5849609 21.9927348,19.0986328 L21.9869975,19.25 L19.9869975,19.25 L19.9869975,17.25 C19.9869975,15.6354167 18.1100443,15.5849609 17.9927348,17.0986328 L17.9869975,17.25 L15.9869975,17.25 L15.9869975,9.25 C15.9869975,7.63541667 14.1100443,7.58496094 13.9927348,9.09863281 Z M30.136652,4.31863347 L36.1127381,9.09950228 L30.136652,13.8803711 L28.8872619,12.3186335 L31.7850423,9.99963347 L20,10 L20,8 L31.5370423,7.99963347 L28.8872619,5.88037109 L30.136652,4.31863347 Z",
    id: ".._.._src_svg_Icn_40px_Hand_Swipe__path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-18.7%",
    y: "-18.8%",
    width: "137.4%",
    height: "137.6%",
    filterUnits: "objectBoundingBox",
    id: ".._.._src_svg_Icn_40px_Hand_Swipe__filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Hand_Swipe__Icn/40px/Hand_Swipe",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Hand_Swipe__Combined-Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 1,
    filter: "url(#.._.._src_svg_Icn_40px_Hand_Swipe__filter-2)",
    xlinkHref: "#.._.._src_svg_Icn_40px_Hand_Swipe__path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#.._.._src_svg_Icn_40px_Hand_Swipe__path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSwipe);
export default __webpack_public_path__ + "static/media/Hand_Swipe.f56e4fd094d78b2400db0aae08e5b6de.svg";
export { ForwardRef as ReactComponent };